import React, {PureComponent} from 'react';
import axios from "axios";
import Config from "../../components/axios/Config";
import Cookie from "js-cookie";
import SwalToast from "../../components/helpers/SwalToast";
import RoutePath from "../../components/RoutePath";
import ErrorDiv from "../../components/helpers/ErrorDiv";
import IsEmpty from "../../components/helpers/IsEmpty";

class ResetPassword extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isValidToken: false,
            button_disabled: false,
            new_password: '',
            confirm_password: '',
            error_new_password: '',
            error_confirm_password: '',
        };
        this.validateResetToken = this.validateResetToken.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.validateResetToken();
    }

    validateResetToken() {
        axios.post(`${process.env.REACT_APP_BASE_API_URL}validate-reset-password`, {
            token: this.props.match.params.token,
        }, Config()).then(response => {
            this.setState({
                isValidToken: true
            });
        }).catch(error => {
            this.props.history.push({
                pathname: RoutePath.LOGIN
            });
        }).finally(() => {});
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            button_disabled: true,
            error_new_password: '',
            error_confirm_password: '',
        }, () => {
            let new_password = this.state.new_password;
            let confirm_password = this.state.confirm_password;

            if (IsEmpty(new_password)) {
                this.setState({
                    error_new_password: 'The new password field is required.',
                    button_disabled: false,
                });
            } else if (new_password.length < 8) {
                this.setState({
                    error_new_password: 'Minimum 8 characters.',
                    button_disabled: false,
                });
            } else if (IsEmpty(confirm_password)) {
                this.setState({
                    error_confirm_password: 'The confirm password field is required.',
                    button_disabled: false,
                });
            } else if (confirm_password.length < 8) {
                this.setState({
                    error_confirm_password: 'Minimum 8 characters.',
                    button_disabled: false,
                });
            } else {
                if (new_password === confirm_password) {
                    axios.post(`${process.env.REACT_APP_BASE_API_URL}submit-reset-password`, {
                        token: this.props.match.params.token,
                        new_password: new_password,
                        confirm_password: confirm_password,
                    }, Config()).then(response => {
                        SwalToast.fire({
                            icon: 'success',
                            title: 'Successfully changed!'
                        });
                        this.props.history.push({
                            pathname: RoutePath.LOGIN
                        });
                    }).catch(error => {
                        SwalToast.fire({
                            icon: 'error',
                            title: error.response ? error.response.data.message : 'Whoops, something went wrong!'
                        });
                    }).finally(() => {
                        this.setState({
                            button_disabled: false,
                        });
                    });
                } else {
                    this.setState({
                        error_confirm_password: 'Password does not match!',
                        button_disabled: false,
                    });
                }
            }
        });
    }

    render() {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
                {this.state.isValidToken &&
                <div className="card shadow-graph p-3" style={{width: '24rem'}}>
                    <form className="m-0 p-0" onSubmit={this.handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="new-password" className="color-374650">New Password</label>
                            <input
                                required
                                autoComplete={"new-password"}
                                id="new-password"
                                type="password"
                                className="form-control"
                                value={this.state.new_password}
                                onChange={event => this.setState({
                                    new_password: event.target.value
                                })}
                            />
                            <ErrorDiv error={this.state.error_new_password} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="confirm-password" className="color-374650">Confirm Password</label>
                            <input
                                required
                                autoComplete={"confirm-password"}
                                id="confirm-password"
                                type="password"
                                className="form-control"
                                value={this.state.confirm_password}
                                onChange={event => this.setState({
                                    confirm_password: event.target.value
                                })}
                            />
                            <ErrorDiv error={this.state.error_confirm_password} />
                        </div>
                        <button type="submit" className="btn bgc-374650 shadow-graph text-white font-weight-bold mt-3">Submit</button>
                    </form>
                </div>}
            </div>
        );
    }
}

export default ResetPassword;